import { FC, ReactNode } from "react";
import { View, StyleSheet } from "@react-pdf/renderer";

import { CardAvatarLayout } from "..";

type Side = {
  label: string;
  value: string;
  content?: ReactNode;
};

type Props = {
  left: Side;
  right: Side;
};

const styles = StyleSheet.create({
  wrapper: {
    // former "sides"
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    columnGap: 12,
  },
});

export const CardSidedLayout: FC<Props> = ({ left, right }) => {
  return (
    <View style={styles.wrapper}>
      <CardAvatarLayout label={left.label} value={left.value}>
        {left.content}
      </CardAvatarLayout>

      <CardAvatarLayout
        label={right.label}
        value={right.value}
        variant={CardAvatarLayout.variant.GREEN}
      >
        {right.content}
      </CardAvatarLayout>
    </View>
  );
};
